import { CookiesRepository } from '@/core/cookies/domain/CookiesRepository.ts'
import { CookiesUrl } from '@/core/cookies/domain/Cookies.ts'

type GetCookiesUrlUseCaseDependencies = { cookiesRepository: CookiesRepository }

export class GetCookiesUrlUseCase {
  private readonly cookiesRepository: CookiesRepository
  constructor({ cookiesRepository }: GetCookiesUrlUseCaseDependencies) {
    this.cookiesRepository = cookiesRepository
  }

  execute = (hostId: string): Promise<CookiesUrl> => {
    return this.cookiesRepository.getCookiesUrl(hostId)
  }
}
